import React from 'react';
import Grade1Letter from './Grade1Letter';

const ORIGINAL = new Set(['a', 'n', 'e', 't', 'i', 'l']);
// The same 100-unit grid, 10-unit round stroke and lesson baseline as an.
// Original lesson masters above are delegated unchanged; new letters are local
// to classroom balloon words and do not alter the student lesson renderer.
const OUTLINES = {
  // These two bodies are used only for circumflex composition; plain a/i
  // still delegate to the original lesson component below.
  a: <><circle cx="46" cy="54" r="28" /><path d="M74 26V82" /></>,
  i: <path d="M50 39V80" />,
  b: <><path d="M22 14V82" /><circle cx="50" cy="54" r="28" /></>,
  c: <path d="M76 32C59 17 24 22 22 53C20 83 58 94 76 75" />,
  d: <><circle cx="50" cy="54" r="28" /><path d="M78 14V82" /></>,
  f: <path d="M44 82V30Q44 9 68 17M25 39H65" />,
  g: <><circle cx="46" cy="54" r="28" /><path d="M74 26V78Q74 98 49 94" /></>,
  h: <path d="M25 14V80M25 52C25 20 75 20 75 52V80" />,
  'ı': <path d="M50 39V80" />,
  j: <><circle cx="56" cy="19" r="5" fill="currentColor" stroke="none" /><path d="M56 39V80Q56 99 35 91" /></>,
  k: <path d="M26 14V80M75 28L26 59M48 45L78 80" />,
  m: <path d="M16 80V28M16 52C16 20 50 20 50 52V80M50 52C50 20 84 20 84 52V80" />,
  o: <circle cx="50" cy="54" r="28" />,
  p: <><path d="M22 28V94" /><circle cx="50" cy="54" r="28" /></>,
  q: <><circle cx="50" cy="54" r="28" /><path d="M78 28V94" /></>,
  r: <path d="M30 80V28M30 52Q30 23 64 31" />,
  s: <path d="M74 34C61 18 28 22 25 39C21 56 76 48 75 68C74 86 37 91 22 75" />,
  u: <path d="M25 28V58C25 90 75 90 75 58V28M75 58V80" />,
  v: <path d="M21 28L50 80L79 28" />,
  w: <path d="M12 28L30 80L50 43L70 80L88 28" />,
  x: <path d="M23 28L77 80M77 28L23 80" />,
  y: <path d="M22 28L50 79M78 28L43 94" />,
  z: <path d="M24 28H76L24 80H76" />,
  A: <path d="M18 84L50 14L82 84M30 59H70" />,
  B: <path d="M26 84V14H50C84 14 84 48 50 48H26M50 48C88 48 88 84 50 84H26" />,
  C: <path d="M80 26C68 8 24 8 20 49C16 91 63 99 80 76" />,
  D: <path d="M26 14V84H46C91 84 91 14 46 14H26" />,
  E: <path d="M78 14H25V84H78M25 48H68" />,
  F: <path d="M78 14H25V84M25 48H68" />,
  G: <path d="M80 26C68 8 24 8 20 49C16 91 63 99 80 76V50H55" />,
  H: <path d="M24 14V84M76 14V84M24 49H76" />,
  I: <path d="M50 14V84" />,
  J: <path d="M73 14V64C73 94 27 95 25 70" />,
  K: <path d="M25 14V84M77 14L25 52L79 84" />,
  L: <path d="M27 14V84H79" />,
  M: <path d="M17 84V14L50 59L83 14V84" />,
  N: <path d="M24 84V14L76 84V14" />,
  O: <ellipse cx="50" cy="49" rx="32" ry="36" />,
  P: <path d="M27 84V14H52C85 14 85 50 52 50H27" />,
  Q: <><ellipse cx="50" cy="49" rx="32" ry="36" /><path d="M61 70L83 94" /></>,
  R: <path d="M27 84V14H52C85 14 85 50 52 50H27M51 50L81 84" />,
  S: <path d="M79 24C67 6 24 9 22 30C19 56 81 40 79 68C77 92 37 99 19 78" />,
  T: <path d="M17 14H83M50 14V84" />,
  U: <path d="M23 14V60C23 96 77 96 77 60V14" />,
  V: <path d="M18 14L50 84L82 14" />,
  W: <path d="M12 14L30 84L50 39L70 84L88 14" />,
  X: <path d="M20 14L80 84M80 14L20 84" />,
  Y: <path d="M18 14L50 50L82 14M50 50V84" />,
  Z: <path d="M20 14H80L20 84H80" />,
  0: <ellipse cx="50" cy="49" rx="27" ry="35" />,
  1: <path d="M35 28L50 14V84M35 84H65" />,
  2: <path d="M24 29C25 5 80 5 77 32C75 45 26 68 23 84H80" />,
  3: <path d="M25 20C60 -1 91 36 51 47C91 44 91 96 25 82" />,
  4: <path d="M68 84V14L20 64H83" />,
  5: <path d="M77 14H29L24 48C88 26 91 97 23 81" />,
  6: <path d="M74 16C38 -1 14 50 25 77C40 102 87 78 66 52C53 37 25 46 23 64" />,
  7: <path d="M20 14H81L40 84" />,
  8: <><ellipse cx="50" cy="32" rx="24" ry="18" /><ellipse cx="50" cy="66" rx="28" ry="21" /></>,
  9: <><ellipse cx="50" cy="35" rx="27" ry="22" /><path d="M77 35C82 70 64 99 30 80" /></>,
  '-': <path d="M28 55H72" />,
  '–': <path d="M20 55H80" />,
  '—': <path d="M12 55H88" />,
  "'": <path d="M53 14L47 30" />,
  '’': <path d="M53 14L47 30" />,
  '.': <circle cx="50" cy="82" r="5" fill="currentColor" stroke="none" />,
  ',': <path d="M52 80L44 94" />,
  ':': <><circle cx="50" cy="38" r="5" fill="currentColor" stroke="none" /><circle cx="50" cy="78" r="5" fill="currentColor" stroke="none" /></>,
  '!': <><path d="M50 16V62" /><circle cx="50" cy="84" r="5" fill="currentColor" stroke="none" /></>,
  '?': <><path d="M27 32C28 9 76 9 76 35C76 52 50 49 50 65" /><circle cx="50" cy="84" r="5" fill="currentColor" stroke="none" /></>,
  '/': <path d="M75 14L25 84" />,
  '(': <path d="M60 10Q25 49 60 90" />,
  ')': <path d="M40 10Q75 49 40 90" />,
  ' ': <></>,
};

const ACCENTED = { 'ç': ['c', 'cedilla'], 'Ç': ['C', 'cedilla'],
  'ğ': ['g', 'breve'], 'Ğ': ['G', 'breve'], 'ö': ['o', 'dots'], 'Ö': ['O', 'dots'],
  'ş': ['s', 'cedilla'], 'Ş': ['S', 'cedilla'], 'ü': ['u', 'dots'], 'Ü': ['U', 'dots'],
  'İ': ['I', 'dot'], 'â': ['a', 'hat'], 'Â': ['A', 'hat'],
  'î': ['i', 'hat'], 'Î': ['I', 'hat'], 'û': ['u', 'hat'], 'Û': ['U', 'hat'] };
export const CLASSROOM_TURKISH_ALPHABET = 'abcçdefgğhıijklmnoöprsştuüvyz';

export function classroomGlyphMetrics(letter) {
  if ('ilıIİ'.includes(letter)) return { advance: .3, offset: -.35 };
  if ('mwMW'.includes(letter)) return { advance: .95, offset: -.025 };
  if (letter === 'r') return { advance: .6, offset: -.2 };
  if ('ft'.includes(letter)) return { advance: .65, offset: -.175 };
  if (" '’.,:!()".includes(letter)) return { advance: .4, offset: -.3 };
  return { advance: .75, offset: -.14 };
}

export function classroomGlyphSupported(letter) {
  return ORIGINAL.has(letter) || Object.prototype.hasOwnProperty.call(OUTLINES, letter)
    || Object.prototype.hasOwnProperty.call(ACCENTED, letter);
}

export function classroomWordUnits(word) {
  return [...word].reduce((sum, letter) => sum + classroomGlyphMetrics(letter).advance, 0);
}

function Accent({ type, capital }) {
  const top = capital ? 0 : 12;
  if (type === 'cedilla') return <path d="M49 90L44 96H54" strokeWidth="6" />;
  if (type === 'breve') return <path d={capital ? 'M35 -2Q50 12 65 -2' : 'M35 7Q50 21 65 7'} strokeWidth="6" />;
  if (type === 'hat') return <path d={capital ? 'M37 -4L50 -14L63 -4' : 'M37 12L50 2L63 12'} strokeWidth="6" />;
  if (type === 'dot') return <circle cx="50" cy={top} r="5" fill="currentColor" stroke="none" />;
  return <><circle cx="38" cy={top} r="4.5" fill="currentColor" stroke="none" /><circle cx="62" cy={top} r="4.5" fill="currentColor" stroke="none" /></>;
}

export default function ClassroomSchoolLetter({ letter }) {
  if (ORIGINAL.has(letter)) return <Grade1Letter letter={letter} />;
  const accented = ACCENTED[letter];
  const supported = classroomGlyphSupported(letter);
  return <svg viewBox="0 0 100 100" aria-hidden="true" data-testid={`classroom-school-${letter}`}
    data-unsupported={supported ? undefined : 'true'} fill="none" stroke="currentColor"
    strokeWidth="10" strokeLinecap="round" strokeLinejoin="round">
    {OUTLINES[accented ? accented[0] : letter] || OUTLINES['?']}
    {accented && <Accent type={accented[1]} capital={letter === letter.toLocaleUpperCase('tr-TR')} />}
  </svg>;
}
